import TooltipSystem from './TooltipSystem';
import './TooltipSystem.scss';

export default TooltipSystem;
